import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterDataResolved } from '@ngxs/router-plugin';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetTitle } from './rt-titles.actions';
import { RT_TITLES_STATE_DEFAULT, RtTitlesStateModel } from './rt-titles.model';
import { RtTitlesService } from './rt-titles.service';

@State<RtTitlesStateModel>({
  name: 'rtTitles',
  defaults: RT_TITLES_STATE_DEFAULT
})

@Injectable()
export class RtTitlesState {
  constructor(private titleService: Title, private rtTitlesService: RtTitlesService) {
  }

  @Selector()
  static currentTitle(state: RtTitlesStateModel): string {
    return state?.currentTitle;
  }


  @Action(RouterDataResolved)
  setTitle(ctx: StateContext<RtTitlesStateModel>, { routerState }: RouterDataResolved<any>) {
    let { root: route } = routerState;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const { data } = route;

    const title = data && data['title'] ? data['title'] : '';
    ctx.patchState({ currentTitle: title });
    this.titleService.setTitle(this.rtTitlesService.formatTitle(title));
  }

  @Action(SetTitle)
  setTitleAction(ctx: StateContext<RtTitlesStateModel>, { title }: SetTitle) {
    ctx.patchState({ currentTitle: title });
    this.titleService.setTitle(this.rtTitlesService.formatTitle(title));
  }
}
